module.exports = __webpack_public_path__ + "img/初出茅庐.55c0532f.png";